import GetVersionL10nId from '../../gw-portals-platform-js/versionName/GetVersionL10nId';

// HELPERS
/**
 * Sets the document title
 * @param {Object} $translate - Angular translate service
 * @param {String} l10nId - l10n ID to be used
 */
function setDocTitle(_ref) {
    var $translate = _ref.$translate,
        l10nId = _ref.l10nId;

    $translate(l10nId).then(function (translatedValue) {
        document.title = translatedValue;
    }).catch(console.error);
}

/**
 * Sets the global document title depending on the versions available for the app
 * @param {Object} $translate - Angular translate service
 * @param {String} [translationIdBase] - prefix of the l10n ID (if the versionName is available) or the l10n ID to be used
 */
export default (function (_ref2) {
    var $translate = _ref2.$translate,
        translationIdBase = _ref2.translationIdBase;

    var l10nId = GetVersionL10nId(translationIdBase);

    setDocTitle({ $translate: $translate, l10nId: l10nId });
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-platform-angular/versionName/SetVersionDocumentTitle.js
// module id = 320
// module chunks = 0